import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { take } from 'rxjs';
import { ConfigService } from "src/app/services/config/config.service";
import { RewardsService } from 'src/app/services/rewards/rewards.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { EventsService } from 'src/app/services/event/event.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';

@Component({
  selector: 'app-my-rewards',
  templateUrl: './my-rewards.component.html',
  styleUrls: ['./my-rewards.component.scss'],
})
export class MyRewardsComponent implements OnInit {

  @Output() onClickInfo: EventEmitter<any> = new EventEmitter();
  @Input('useMenuOpenEvent') useMenuOpenEvent: boolean = false;
  public earnedMonthly = 0;
  public totalRedeemPoints = 0;
  private nextLevelPoints = 0;
  public rewardCardImg = '';
  public toNextLevel: number = 0;
  public title: string = "";
  public rpMonthToDateLabel: string = "";
  public rpRedeemLabel: string = "";
  private currentLoyaltyLevel: number = 0;
  private menuOpenEvent: string = 'event:menu:will:open';
  public isLoading: boolean = true;


  constructor(private config: ConfigService,
    private utils: UtilsService,
    private rewardService: RewardsService,
    private userSessionService: UserSessionService,
    private eventsService: EventsService,
    private balanceProvider: AccountBalanceService) {
    this.balanceProvider.getBalance().subscribe(
      (response) => {
        const accountBalances = response;
        const totalRewards = Number(accountBalances?.RWP?.total) || 0;
        this.totalRedeemPoints = Math.trunc(totalRewards);
      });
  }

  ngOnInit() {
    this.setDefaultCardImages();
    this.initialize();
  }

  private initialize() {
    if (this.useMenuOpenEvent) {
      this.eventsService.destroy(this.menuOpenEvent)
      this.eventsService.subscribe(this.menuOpenEvent, () => {
        this.showLoader();
        this.checkCardTier();
      });
    } else {
      this.showLoader();
      this.checkCardTier();
    }
    this.setConfigValues();
  }

  private setDefaultCardImages() {
    let imgNameCheckmark = "resorts_" + "1" + ".png";
    this.rewardCardImg = this.utils.getCDNAsset("rewardcards/" + imgNameCheckmark);
  }

  private setRewardsImg() {
    // the reward card images need to configure from CDN.
    let imgNameCheckmark = "resorts_" + this.currentLoyaltyLevel + ".png";
    if (this.currentLoyaltyLevel) {
      this.rewardCardImg = this.utils.getCDNAsset("rewardcards/" + imgNameCheckmark);
    } else {
      this.setDefaultCardImages();
    }
  }

  private checkCardTier() {
    this.userSessionService.getCustomer().pipe(take(2)).subscribe(async res => {
      if (res?.customerId) {
        this.balanceProvider.updateBalance();
        this.rewardService.removeLoyaltyPoints();
        await new Promise(resolve => setTimeout(resolve, 600));
        const response: any = await this.rewardService.callGetLoyaltyPoints(res?.customerId);
        this.currentLoyaltyLevel = response?.currentTier;
        this.earnedMonthly = Math.trunc(response?.totalRewardsMonth);
        this.nextLevelPoints = Math.trunc(response?.nextLevelPoints);
        this.toNextLevel = response?.currentProgress ? Math.trunc(response?.currentProgress) : 0;
        this.setRewardsImg()
        this.hideLoader();
      } else {
        this.hideLoader();
      }
    });
  }

  private showLoader() {
    this.isLoading = true;
  }

  private hideLoader() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  private setConfigValues() {
    const config = this.config.getConfig();
    this.title = config.FEATURE_MYREWARDS_TITLE ?? "My Rewards";
    this.rpMonthToDateLabel = config.FEATURE_MYREWARDS_MONTH_TO_DATE_LABEL ?? "RP's month to date";
    this.rpRedeemLabel = config.FEATURE_MYREWARDS_RP_TO_REDEEM_LABEL ?? "RP's to redeem";
  }

  public clickInfo() {
    this.onClickInfo.emit();
  }

}